import { Record } from 'immutable'
import { MembershipType } from './enums'

export interface IMembership {
  readonly authenticatorId: string
  readonly type: MembershipType
}

const MembershipRecord = Record({
  authenticatorId: '',
  type: '',
})

export class Membership extends MembershipRecord implements IMembership {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Membership()
    }

    const { ...rest } = initialState

    return new Membership({
      ...rest,
    })
  }

  public readonly authenticatorId: string
  public readonly type: MembershipType

  constructor(props?: Partial<Membership>) {
    props ? super(props) : super()
  }
}
